import { render, staticRenderFns } from "./photoEdit.vue?vue&type=template&id=79648124&"
import script from "./photoEdit.vue?vue&type=script&lang=js&"
export * from "./photoEdit.vue?vue&type=script&lang=js&"
import style0 from "./photoEdit.vue?vue&type=style&index=0&id=79648124&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports